module.exports = __webpack_public_path__ + "static/dedicationCover-77284f18181ce17fcc90a45c42117eaf.jpg";